import ContractElement from './contract_element.vue';

export default ContractElement;
